export default __webpack_public_path__ + "static/media/dashboard-logo.3a13a211.svg";